/**
 * Modo de lectura para `POST /users/get-adhesion-details` (Fase 3 backend).
 *
 * El frontend pasa el modo correspondiente a la vista que renderiza:
 *   - `MiBeneficioV2` (vista Empleado B2B) → `'EMPLOYMENT'`
 *   - `IndividualDashboardV2` (vista Personal) → `'INDIVIDUAL'`
 *   - Vistas de autónomo → `'FREELANCE'`
 *
 * Si se omite, el backend deriva del estado físico del user
 * (comportamiento backward compat). Necesario para usuarios "mixtos"
 * (B2B con rol 'individual' que tienen plan empleo Y plan individual
 * en el mismo `user_id`).
 *
 * El enum se duplica en comparsa (`src/users/dto/get-adhesion-details-input.dto.ts`).
 * Mantener sincronizado.
 */
export type AdhesionMode = 'INDIVIDUAL' | 'EMPLOYMENT' | 'FREELANCE';

/**
 * `userEppConfigId` acota la lectura a UN plan concreto. Con dos planes del
 * mismo tipo, `mode` no nombra una fila: el backend resuelve por orden y se
 * pintarían los saldos de un plan que el usuario no eligió.
 */
const getAdhesionDetails = async (
	token: string,
	mode?: AdhesionMode,
	userEppConfigId?: string
) => {
	const payload = {
		...(mode ? { mode } : {}),
		...(userEppConfigId ? { userEppConfigId } : {})
	};

	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/get-adhesion-details`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		...(Object.keys(payload).length > 0 ? { body: JSON.stringify(payload) } : {})
	});

	return response.json();
};

export default getAdhesionDetails;
